module.exports = __webpack_public_path__ + "static/img/jyzytj.c12de1b2.png";